import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={43}
    height={47}
    viewBox={'0 0 43 47'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G filter="url(#a)" opacity={0.5}>
      <Path
        fill="url(#b)"
        d="M39 27.897V11.034a2.34 2.34 0 0 0-1.19-2.103L22.69.315a2.412 2.412 0 0 0-2.385 0L5.19 8.931A2.324 2.324 0 0 0 4 10.962V27.97a2.32 2.32 0 0 0 1.174 1.964l15.115 8.744a2.41 2.41 0 0 0 2.411 0l15.115-8.744a2.32 2.32 0 0 0 1.174-1.965v-.071H39Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={21.5}
        x2={21.5}
        y1={39}
        y2={0.003}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0} />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
